import { periodTypes } from "../mls-match-list/utils";
import { matchEventSubtypes, matchEventTypes } from "../mls-match-summary/utils";
import { highlightTypes } from "../shared/utils";

export const feedTypes = {
  goal: 'goal',
};

export function getFeedType(type) {
  switch (type) {
    case feedTypes.goal:
    default: {
      return null;
    }
  }
}

export function mergeFeedWithVideosAndPlayers({ feed, homeClub, mlsMatch, awayClub, videoList, players }) {
  if (!feed || feed.length === 0) {
    return null;
  }

  const { match_information } = mlsMatch;
  const { home_team_goals = 0, away_team_goals = 0, home_team_penalty_goals = 0, away_team_penalty_goals = 0 } = match_information;

  let homeScore = home_team_goals + home_team_penalty_goals;
  let awayScore = away_team_goals + away_team_penalty_goals;

  const composedFeed = [];

  for (let i = 0; i < feed.length; i++) {
    const current = feed[i] || {};
    const { player_id, team_id, second_player_id } = current;
    const isHome = team_id === homeClub?.team_id;
    const isAway = team_id === awayClub?.team_id;

    const isLastTimingCommentary = current?.type === matchEventTypes.startOfPeriod && current?.period === periodTypes.FirstHalf;

    const matchedVideo = videoList != null && videoList.length > 0 ? videoList.find(video => {
      const { fields } = video || {};
      const { sportecEventId } = fields || {};

      return sportecEventId === current?.event_id;
    }) : null;

    const matchedPlayer = Array.isArray(players) ? players?.find(player => player?.person_id === player_id) || null : null;
    const secondMatchedPlayer = second_player_id ? Array.isArray(players) ? players?.find(player => player?.person_id === second_player_id) || null : null : null;

    const { thumbnail, headshotNationalTeam, headshotClub } = matchedPlayer || {};

    let adjustedHomeScore = homeScore;
    let adjustedAwayScore = awayScore;

    if (team_id) {
      if (current.type === matchEventTypes.goal) {
        if (isHome) {
          adjustedHomeScore = adjustedHomeScore - 1;
        }
        else if (isAway) {
          adjustedAwayScore = adjustedAwayScore - 1;
        }
      }

      if (current.sub_type === matchEventSubtypes.ownGoal) {
        if (team_id == homeClub?.sportecId) {
          adjustedAwayScore = adjustedAwayScore - 1;
        }
        else if (team_id == awayClub?.sportecId) {
          adjustedHomeScore = adjustedHomeScore - 1;
        }
      }
    }

    composedFeed.push({
      ...current,
      first_player: composePlayer(matchedPlayer),
      second_player: composePlayer(secondMatchedPlayer),
      headshotNationalTeam: headshotNationalTeam != null ? headshotNationalTeam : null,
      headshotClub: headshotClub != null ? headshotClub : null,
      image: thumbnail != null ? thumbnail : null,
      video: matchedVideo != null ? matchedVideo : null,
      homeScore,
      awayScore,
      isLastTimingCommentary,
      scoreChange: adjustedHomeScore !== homeScore
        ? "home"
        : adjustedAwayScore !== awayScore
          ? "away"
          : null
    });

    homeScore = adjustedHomeScore;
    awayScore = adjustedAwayScore;
  }

  return composedFeed;
}

function composePlayer(player = {}) {
  return {
    ...player,
    known_name: player?.short_name,
    full_name: `${player?.first_name} ${player?.last_name}`,
    position: player?.playing_position,
    jersey: player?.shirt_number,
    slug: player?.slug ,
  }
}

export function mergePlayers({ away, home }) {
  return [...away?.players, ...home?.players];
}

export function mergePages(pages = []) {
  return pages && pages.length > 0 ? pages.reduce((accum, current = []) => {
    return [...accum, ...current];
  }, []) : [];
}

export function composeVideoList(forgeVideos, validators) {
  if (forgeVideos == null) {
    return [];
  }

  const {
    fullGameTags,
    condensedGameTags,
    gameHighlightsTags
  } = validators || {};

  return forgeVideos.map(v => {
    const { tags } = v || {};

    if (tags == null) {
      return v;
    }

    const tagList = [];
    for (let i = 0; i < tags.length; i++) {
      const currentTag = tags[i];
      const neutralSlug = currentTag?.neutralSlug;

      if (neutralSlug != null) {
        tagList.push(neutralSlug);
      }
    }

    const isFullGame = tagValidator(tagList, fullGameTags);
    const isCondensedGame = tagValidator(tagList, condensedGameTags);
    const isGameHighlights = tagValidator(tagList, gameHighlightsTags);

    return {
      ...v,
      fields: {
        ...v.fields,
        highlightType: isFullGame
          ? highlightTypes.fullGame
          : isCondensedGame
            ? highlightTypes.condensedGame
            : isGameHighlights
              ? highlightTypes.gameHighlights
              : null
      }
    };
  });
}

export function removeDuplicates(items = [], key = "") {

  if (!Array.isArray(items) || !key) {
    return []
  }

  const itemIds = {};

  items.forEach(item => {
    itemIds[item[key]] = item;
  })

  return Object.values(itemIds);

}

function tagValidator(arr, target) {
  if (arr == null || target == null) {
    return false;
  }

  return target.every(v => arr.some(x => x.includes(v)));
}
